import React, {Component} from 'react';

import { cf } from './c_20210415a_YSh/cf';
import { ce } from './c_20210415a_YSh/ce';
import { iv } from './c_20210415a_YSh/iv';
import { ic } from './c_20210415a_YSh/ic';
import { cp } from './c_20210415a_YSh/cp';
import { ip } from './c_20210415a_YSh/ip';
import { bf } from './c_20210415a_YSh/bf';

import cView from './c_20210415a_YSh/cView';

class iMthDtl extends cView{

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }
  //
  $id_stss = {
    //
    sld_it50ss: [],
    sld_it61ss: [],
    //
//    s_it60d110: bf.myDT_get_date('today', +1).substr(0,7),
    s_it60d110: bf.myDT_get_date('today').substr(0,7),
    s_it60i110: '0',
    s_it60i210: '0',
    s_it60i310: '0',
    s_it60i320: '0',
    s_it60i330: '0',
    s_it60i340: '0',
    s_it60i410: '0',
    s_it60i510: '0',
    s_it60i610: '0',
    s_it60i710: '0',
    s_it60i810: '0',
    s_it60i820: '0',
    s_it60i830: '0',
    s_it60i840: '0',
    s_it60i850: '0',
    s_it60i860: '0',
    s_it60i8a0: '0',
    s_it60i910: '0',
    s_it60i880: '0',
    s_it60i930: '0',
    s_it60ia10: '0',
    s_it60ib10: '0',
    s_it60ib20: '0',
    s_it60ib30: '0',
    s_it60ib40: '0',
    s_it60ic10: '0',
    s_it60ic20: '0',
    s_it60ic30: '0',
    s_it60ic40: '0',

    sgcn_pageTab: 1,

    s_dsp010: '0',
    s_dsp020: '0',
    s_dsp030: '0',
    s_dsp040: '0',
    s_dsp050: '0',
    s_dsp060: '0',
    s_dsp070: '0',
    s_dsp080: '0',
    s_dsp090: '0',
    s_dsp100: '0',
    s_dsp110: '0',
    s_dsp120: '0',

  };
  //  
  $ilp_loads = () => [
    ip.$ip_load_it60({
      b_clr: (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'new') ? true : false,
      mode: 'set',
      it60_key: global.c?.state.sgcd_pageCmns?.it60_key,
    }),
    new Promise( _o_end1 => { // 月別時間帯別情報
      if (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'show') { // 既存
        global.c?._load_it61({
          it60_key: global.c?.state.sgcd_pageCmns?.it60_key,
        })
        .then(() => {
          _o_end1();
        })
      }
      else {
        _o_end1();
      }
    }),
    new Promise( _o_end1 => { // 日別情報
      if (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'show') { // 既存
        ip.$ip_load_it50({
          mode: 'items',
          state: 'sld_it50ss',
          it60_key: global.c?.state.sgcd_pageCmns?.it60_key,
        })
        .then(() => {
          _o_end1();
        })
      }
      else {
        _o_end1();
      }
    }),
  ];
  //

  _load_it61 = pd_prms => { // 月別時間帯別情報
    return new Promise( _o_end1 => {
      new Promise( _o_end2 => {
        if (bf.f(pd_prms.it60_key)) { // 月次情報が指定されている場合
//          let _cnd = bf.q(`[it61b21k]="{}" AND [it61d210]>="19" AND [it61d210]<="29"`.f(
          let _cnd = bf.q(`[it61b21k]="{}"`.f(
            pd_prms.it60_key,
          ));
          _o_end2(_cnd);
        }
        else {
          alert('incorrect prms at _load_it61: {}'.f(pd_prms))
        };
      })
      .then( _cnd => {
        cf.myCB_set_clds({
          ctr: 'nlm', 
          elm: 'it61', 
          n_dms: 3, 
          cnd: _cnd,
          state: 'sld_it61ss',
        })
        .then( () => {
          _o_end1();
        });
      });
    });
  };

  $ilp_bfrIuds = () => [
  ];

  $ip_ins = () => new Promise( _o_end1 => {
    let _cnd = bf.q('[it60b11k]="{}" AND [it60d110]="{}"'.f(
      global.c?.state.sgcd_pageCmns?.cm20_key,
      global.c?.state.s_it60d110,
    ));
    cf.myCB_call_slc({
      ctr: 'nlm', 
      elm: 'it60', 
      n_dms: 2, 
      cnd: _cnd
    })
    .then( _d_it60s => {
      if (!bf.f(_d_it60s)) {
        let _d_vals = {
          it60b11k: global.c?.state.sgcd_pageCmns?.cm20_key,
          it60d110: global.c?.state.s_it60d110,
        };
        cf.myCB_call_iud({
          ctr: 'ins', 
          elm: 'it60', 
          d_vals: _d_vals
        })
        .then( _d_it60s => {
/*
            cf.myRN_pll([
              ip.$ip_ins_it50s({
                d_it60s: _d_it60s,
              }),
              new Promise( async _o_end2 => {
                for await (let [_idx, _timeZone] of bf.e(bf.myCM_get_rng(41, 17))) { // 月別時間帯別情報の新規登録
                  let _d_vals = {
                    it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key,
                    it61b21k: _d_it60s._KEY,
                    it61d110: global.c?.state.s_it60d110,
                    it61d210: _timeZone,
                    it61i110: '0',
                  };
                  await cf.myCB_call_iud({
                    ctr: 'ins', 
                    elm: 'it61', 
                    d_vals: _d_vals
                  })
                };
                _o_end2();
              }),
            ])
            .then(() => {
              cf.myRN_setCmns({
                it60_key: _d_it60s._KEY,
              })
              .then(() => {
                _o_end1(true);
              });
            })
*/
/*
          cf.myRN_setCmns({
            it60_key: _d_it60s._KEY,
          })
          .then(() => {
            ip.$ip_ins_it50s({
              d_it60s: _d_it60s,
            })
            .then( async () => {

              let _timeZone = null;
              let _d_vals = null;

              _timeZone = 17;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 18;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 19;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 20;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 21;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 22;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 23;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 24;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 25;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 26;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 27;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 28;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 29;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 30;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 31;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 32;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 33;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 34;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 35;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 36;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 37;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 38;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 39;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 40;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _timeZone = 41;
              _d_vals = { it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key, it61b21k: _d_it60s._KEY, 
                it61d110: global.c?.state.s_it60d110, it61d210: _timeZone,it61i110: '0', };
              await cf.myCB_call_iud({ ctr: 'ins', elm: 'it61', d_vals: _d_vals});

              _o_end1(true);

            })
          });
*/
          cf.myRN_setCmns({
            it60_key: _d_it60s._KEY,
          })
          .then(() => {
            ip.$ip_ins_it50s({
              d_it60s: _d_it60s,
            })
            .then( async () => {
              for await (let [_idx, _timeZone] of bf.e(bf.myCM_get_rng(41, 17))) { // 月別時間帯別情報の新規登録
//bf.l('353: {}'.f(_timeZone))
                let _d_vals = {
                  it61b11k: global.c?.state.sgcd_pageCmns?.cm20_key,
                  it61b21k: _d_it60s._KEY,
                  it61d110: global.c?.state.s_it60d110,
                  it61d210: _timeZone,
                  it61i110: '0',
                };
                let _cnd = bf.q(`
                  it61b11k="{}" AND 
                  it61b21k="{}" AND 
                  it61d110="{}" AND 
                  it61d210="{}"
                `.f(
                  global.c?.state.sgcd_pageCmns?.cm20_key,
                  _d_it60s._KEY,
                  global.c?.state.s_it60d110,
                  _timeZone,
                ));
                await cf.myCB_call_iud({
                  ctr: 'ins', 
                  elm: 'it61', 
                  d_vals: _d_vals,
                  cnd: _cnd,
                })
//bf.l('378: {}'.f(_timeZone))
              };
//bf.l('388: here')
              _o_end1(true);
            })
          });
        });
      }
      else {
        alert('同一の営業月のデータが存在するため登録できません')
        _o_end1(false);
      };
    });

  });

  $ilp_upds = () => [
    new Promise( _o_end1 => { // 月別情報
      let _d_vals = {
        it60d110: '{}-{}'.f(global.c?.state.s_it60d110.substr(0,4), bf.myCM_pdd(global.c?.state.s_it60d110.substr(5,2), 2)),
        it60i110: bf.n(global.c?.state.s_it60i110),
        it60i210: bf.n(global.c?.state.s_it60i210),
        it60i310: bf.n(global.c?.state.s_it60i310),
        it60i410: bf.n(global.c?.state.s_it60i410),
        it60i510: bf.n(global.c?.state.s_it60i510),
        it60i610: bf.n(global.c?.state.s_it60i610),
        it60i710: bf.n(global.c?.state.s_it60i710),
        it60i810: bf.n(global.c?.state.s_it60i810),
        it60i820: bf.n(global.c?.state.s_it60i820),
        it60i830: bf.n(global.c?.state.s_it60i830),
        it60i840: bf.n(global.c?.state.s_it60i840),
        it60i910: bf.n(global.c?.state.s_it60i910),
        it60i880: bf.n(global.c?.state.s_it60i880),
        it60i930: bf.n(global.c?.state.s_it60i930),
      };
//      let _cnd = bf.q('[_KEY]={}'.f(global.c?.state.sgc_pageKey))
      let _cnd = bf.q('[_KEY]={}'.f(global.c?.state.sgcd_pageCmns?.it60_key))
      cf.myCB_call_iud({
        ctr: 'upd', 
        elm: 'it60', 
        d_vals: _d_vals, 
        cnd: _cnd
      })
      .then(()=>{
        cf.myCB_callQrys({
          l_tgts: ['it60i110', 'it60i510'],
          dd_qryss: ip.dd_qryss,
          d_vals: {
            it60_key: global.c?.state.sgcd_pageCmns?.it60_key,
            it50_key: '___it50_keyErr___',
            it10_key: '___it10_keyErr___',
          },
        })
        .then(() => {
          _o_end1();
        });
      });
    }),
  ];

/*
  _onBlurIt60d110 = () => { // 営業月に準じた情報を表示
    ip.$ip_load_it60({
      mode: 'slc',
      cm20_key: global.c?.state.sgcd_pageCmns?.cm20_key,
      mth: global.c?.state.s_it60d110,
    })
    .then(() => {
      if (bf.f(global.c?.state.sgcd_pageCmns?.it60_key)) {      
        global.c?._load_it61({
          it60_key: global.c?.state.sgcd_pageCmns?.it60_key,
        })
        .then(() => {
        });
      };
    })
  };
*/

  _updDsp010 = pd => new Promise( _o_end1 => { // 売上合計 / 平均 / 予測
      global.c?.setState({
        s_dsp010: '{} / {} / {}'.f(bf.n(global.c?.state.s_it60i210), bf.n(global.c?.state.s_it60i410), bf.n(global.c?.state.s_it60i610)),
      }, () => {
        _o_end1();
      });
  });

  _updDsp020 = pd => new Promise( _o_end1 => { // 利益合計 / 平均 / 予測
      global.c?.setState({
        s_dsp020: '{} / {} / {}'.f(bf.n(global.c?.state.s_it60ib10), bf.n(global.c?.state.s_it60ic10), bf.n(global.c?.state.s_it60id10)),
      }, () => {
        _o_end1();
      });
  });

  _updDsp030 = pd => new Promise( _o_end1 => { // 客数合計 / 平均 / 予測
      global.c?.setState({
        s_dsp030: '{} / {} / {}'.f(bf.n(global.c?.state.s_it60i810), bf.n(global.c?.state.s_it60i850), bf.n(global.c?.state.s_it60i860)),
      }, () => {
        _o_end1();
      });
  });

  _updIt60i610 = pd => new Promise( _o_end1 => {
      global.c?.setState({
        s_it60i610: bf.n(global.c?.state.s_it60i410) * bf.n(global.c?.state.s_it60i510),
      }, () => {
        _o_end1();
      });
  });

  _updIt60id10 = pd => new Promise( _o_end1 => {
      global.c?.setState({
        s_it60id10: bf.n(global.c?.state.s_it60ic10) * bf.n(global.c?.state.s_it60i510),
      }, () => {
        _o_end1();
      });
  });

  _updIt60i860 = pd => new Promise( _o_end1 => {
      global.c?.setState({
        s_it60i860: bf.n(global.c?.state.s_it60i850) * bf.n(global.c?.state.s_it60i510),
      }, () => {
        _o_end1();
      });
  });

  $ild_onChgss = ip.ild_onChgss;

//  $pld_onChgss = () => [];
  $pdo_onChgs = () => ({
//    s_it60i610: () => ip._updIt60i710,
    s_it60i110: () => {
      ip._updIt60i710();
    },
    s_it60i210: () => {
      global.c?._updDsp010();
    },
    s_it60i510: () => {
      global.c?._updIt60i610();
      global.c?._updIt60id10();
      global.c?._updIt60i860();
    },
    s_it60i610: () => {
      ip._updIt60i710();
      global.c?._updDsp010();
    },
    s_it60i810: () => {
      global.c?._updDsp030();
    },
    s_it60i860: () => {
      global.c?._updDsp030();
    },
    s_it60ib10: () => {
      global.c?._updDsp020();
    },
    s_it60id10: () => {
      global.c?._updDsp020();
    },
  });

  render(){
    //
    return (
      <this.$onChg>
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_rhtVsb={true}
        rhtPfx={null}
        onRhtPrs={null}
        d_hdrs={{
          pfx: iv._get_hdrPfx('月別情報（{}）'.f(global.c?.state.s_it60d110)),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]),
          d_subMenus: {
            ld_iss: [
              ip.dd_rptss['日別一覧CSV'],
              ip.dd_rptss['日別責任者一覧CSV'],
              ip.dd_rptss['日別時間帯別一覧CSV'],
              ip.dd_rptss['出勤一覧CSV'],
              ip.dd_rptss['入店時刻一覧CSV'],
              ip.dd_rptss['外販担当者一覧CSV'],
              ip.dd_rptss['入席一覧CSV'],
              ip.dd_rptss['注文一覧CSV'],
              ip.dd_rptss['関与者一覧CSV'],
            ],
          }
        }}
        d_bdys={{
          ld_defss: [
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new'])) ? true : false, // 新規登録後は変更不可
//              b_edt: true, // 新規登録後は変更不可
              state:'s_it60d110',
              pfx:'営業月（YYYY-MM）',
              b_mln:false,
              onBlur: null,
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_it60i510',
              pfx:'営業予定日数',
              b_mln:false,
              b_cmm: true,
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt: (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_it60i110',
              pfx:'売上目標',
              b_mln:false,
//              onBlur: global.c?._onBlurIt60i110,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
/*
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it60i210',
              pfx:'売上実績',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it60i610',
              pfx:'売上予測',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
*/
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_dsp010',
              pfx:'売上合計 / 平均 / 予測',
              b_mln:false,
              b_cmm: true,
/*
              o_stlVal: pd => {
                let _r = bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
bf.l('547: {}'.f(_r));
                return _r;
              },
*/
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it60i450',
              pfx:'平日売上平均',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it60i460',
              pfx:'金・土・祝前売上平均',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it60i470',
              pfx:'日・祝売上平均',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
/*
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it60i410',
              pfx:'平均売上',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false,
              b_edt:false,
              state:'s_it60ib10',
              pfx:'総利益',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false,
              b_edt:false,
              state:'s_it60id10',
              pfx:'利益予測',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
*/
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false,
              b_edt:false,
              state:'s_dsp020',
              pfx:'総利益合計 / 平均 / 予測',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false,
              b_edt:false,
              state:'s_it60ic20',
              pfx:'平日利益平均',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val))
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false,
              b_edt:false,
              state:'s_it60ic30',
              pfx:'金・土・祝前利益平均',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false,
              b_edt:false,
              state:'s_it60ic40',
              pfx:'日・祝利益平均',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
/*
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false,
              b_edt:false,
              state:'s_it60i810',
              pfx:'客数',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it60i860',
              pfx:'集客数予測',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
*/
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_dsp030',
              pfx:'客数合計 / 平均 / 予測',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },

            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it60i8f0',
              pfx:'平日客数平均',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it60i8g0',
              pfx:'金・土・祝前客数平均',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it60i8h0',
              pfx:'日・祝客数平均',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },

            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it60i8b0',
              pfx:'組単価',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false,
              b_edt:false,
              state:'s_it60i820',
              pfx:'客単価',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it60i840',
              pfx:'延長率',
              b_mln:false,
              b_cmm: true,
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false,
              b_edt:false,
              state:'s_it60ia10',
              pfx:'配布枚数',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false,
              b_edt:false,
              state:'s_it60i880',
              pfx:'新規客数',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false,
              b_edt:false,
              state:'s_it60i930',
              pfx:'反響率（%）',
              b_mln:false,
              b_cmm: true,
            },
/*
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it60i310',
              pfx:'経過日数',
              b_mln:false,
              b_cmm: true,
            },
            {
              type:'Inp',
              b_vsb: false,
              b_edt:false,
              state:'s_it60i320',
              pfx:'平日経過日数',
              b_mln:false,
              b_cmm: true,
            },
            {
              type:'Inp',
              b_vsb: false,
              b_edt:false,
              state:'s_it60i330',
              pfx:'休日前経過日数',
              b_mln:false,
              b_cmm: true,
            },
            {
              type:'Inp',
              b_vsb: false,
              b_edt:false,
              state:'s_it60i340',
              pfx:'休日経過日数',
              b_mln:false,
              b_cmm: true,
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1) ? true : false,
              b_edt:false,
              state:'s_it60i710',
              pfx:'目標差異',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: false,
              b_edt:false,
              state:'s_it60i850',
              pfx:'平均客数',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false,
              b_edt:false,
              state:'s_it60ia30',
              pfx:'配布枚数予測',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false,
              b_edt:false,
              state:'s_it60i910',
              pfx:'外販客数',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false,
              b_edt: false,
              state:'s_it60i8a0',
              pfx:'新規客数予測',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false,
              b_edt:false,
              state:'s_it60i870',
              pfx:'組数',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
            {
              type:'Inp',
              b_vsb: (global.c?.state.sgcn_pageTab == 1 && global.c?.state.sgcd_pageCmns?.userc410 == '80') ? true : false,
              b_edt:false,
              state:'s_it60i830',
              pfx:'延長客数',
              b_mln:false,
              b_cmm: true,
              o_stlVal: pd => {
                return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
              },
            },
*/
            {
              type: 'List',
              b_vsb: (global.c?.state.sgcn_pageTab == 2) ? true : false,
              pfx: '',
              state: 'sld_it50ss',
              nextRole: 'own2',
              nextPage: 'iDayDtl',
              nextMode: 'show',
              keyName: 'it50_key',
              b_prs: true,
              b_edt: false,
              b_img: false,
              b_bdr: false,
            },
            {
              type: 'Clds',
              b_vsb: (global.c?.state.sgcn_pageTab == 3) ? true : false,
              b_edt: false,
              state: 'sld_it61ss',
//              pfx: '時間帯別情報（{it61d210}時）',
              o_pfx: _d_is => '時間帯別情報（{}時）'.f(_d_is.it61d210),
              dd_defss: {
                it61i110:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: false,
                  pfx: '総入店客数',
                  b_mln: false,
                  o_stlVal: pd => {
                    return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
                  },
                },
                it61i320:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: false,
                  pfx: '平日入店客数平均',
                  b_mln: false,
                  ini: '0.0',
                  o_stlVal: pd => {
//                    return bf.myCM_cnv('cmm', bf.myCM_cnv('han', pd.val));
                    return bf.myCM_cnv('cmm', bf.n(bf.myCM_cnv('han', pd.val)).toFixed(2));
                  },
                },
                it61i330:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: false,
//                  pfx: '休日前入店客数平均',
                  pfx: '金・土・祝前入店客数平均',
                  b_mln: false,
                  ini: '0.0',
                  o_stlVal: pd => {
                    return bf.myCM_cnv('cmm', bf.n(bf.myCM_cnv('han', pd.val)).toFixed(2));
                  },
                },
                it61i340:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: false,
//                  pfx: '休日入店客数平均',
                  pfx: '日・祝日入店客数平均',
                  b_mln: false,
                  ini: '0.0',
                  o_stlVal: pd => {
                    return bf.myCM_cnv('cmm', bf.n(bf.myCM_cnv('han', pd.val)).toFixed(2));
                  },
                },
              },
            },
          ],
        }}
        d_btms={{
          n_h: ic.gn_fontSizeNrm + ic.gn_bdrWNrw * 2 + ic.gn_mgnNrm * 4,
          ld_defss: [
            {
              type: 'Btns',
              b_vsb: true,
              ld_defss: [
                {
                  pfx: '基本情報',
                  b_vsb: true,
                  b_rvs: (global.c?.state.sgcn_pageTab == 1) ? false : true,
                  onPrs: () => global.c?.$onPrsTab({n_tab: 1}),
                  stlBtn: {
                    width: ic.gn_btnWLrg,
                  },
                  stlPfx: {
                  },
                },
                {
                  pfx: '日別情報',
                  b_vsb: true,
                  b_rvs: (global.c?.state.sgcn_pageTab == 2) ? false : true,
                  onPrs: () => global.c?.$onPrsTab({n_tab: 2}),
                  stlBtn: {
                    width: ic.gn_btnWLrg,
                  },
                  stlPfx: {
                  },
                },
                {
                  pfx: '時間帯別情報',
                  b_vsb: true,
                  b_rvs: (global.c?.state.sgcn_pageTab == 3) ? false : true,
                  onPrs: () => global.c?.$onPrsTab({n_tab: 3}),
                  stlBtn: {
                    width: ic.gn_btnWLrg,
                  },
                  stlPfx: {
                  },
                },
              ],
              stlCta: {
                marginTop: ic.gn_mgnLrg,
                marginBottom: ic.gn_mgnLrg,
              },
            },
          ],
        }}
      />
      </this.$onChg>
    );
  }        
}

export default iMthDtl;

